import h from 'hyperscript';

import { closePopup } from 'ui/popup/popup';
import { RadioGroup } from 'ui/radio-group/radio-group';

import { uniqueId } from 'cadenza/utils/unique-id';
import { CaseSensitivity, CombinationType, FilterType } from 'cadenza/api-client/conditions/like-condition-api';
import 'cadenza/conditions/like-condition/like-condition-dropdown.css';
import i18n from 'cadenza/conditions/like-condition/messages.properties';

const COMPONENT_NAME = 'd-like-condition-dropdown';

export const DEFAULT_FILTERTYPE = FilterType.SUBSTRING;
export const DEFAULT_CASESENSITIVITY = CaseSensitivity.INSENSITIVE;
export const DEFAULT_COMBINATIONTYPE = CombinationType.OR;

export class LikeConditionDropdown extends HTMLElement {

  _filterTypeRadioGroup;
  _caseSensitivityCheckBox;
  _combinationTypeRadioGroup;

  constructor ({ filterType = DEFAULT_FILTERTYPE, caseSensitivity = DEFAULT_CASESENSITIVITY, combinationType = DEFAULT_COMBINATIONTYPE } = {}) {
    super();
    this._createDialogContent(filterType, caseSensitivity, combinationType);
  }

  connectedCallback () {
    this.classList.add(COMPONENT_NAME);
  }

  get returnValue () {
    const filterType = this._filterTypeRadioGroup.value;
    const caseSensitivity = this._caseSensitivityCheckBox.checked ? CaseSensitivity.SENSITIVE : CaseSensitivity.INSENSITIVE;
    const combinationType = this._combinationTypeRadioGroup.value;
    return { filterType, caseSensitivity, combinationType };
  }

  _createDialogContent (filterType, caseSensitivity, combinationType) {
    const filterTypeOptions = FilterType.values.map(type => ({
      value: type, label: i18n(`filtertype.${type.toLowerCase()}`)
    }));
    this._filterTypeRadioGroup = new RadioGroup(filterTypeOptions, {
      initialValue: filterType || DEFAULT_FILTERTYPE
    });
    this._caseSensitivityCheckBox = h('input', {
      type: 'checkbox',
      name: 'caseSensitivity',
      checked: caseSensitivity === CaseSensitivity.SENSITIVE
    });
    const combinationTypeLabelId = uniqueId();
    const combinationTypeOptions = CombinationType.values.map(type => ({
      value: type, label: i18n(`combinationtype.${type.toLowerCase()}`)
    }));
    this._combinationTypeRadioGroup = new RadioGroup(combinationTypeOptions, {
      initialValue: combinationType || DEFAULT_COMBINATIONTYPE,
      ariaLabelledBy: combinationTypeLabelId
    });

    this.append(
      h('.form-group', [ this._filterTypeRadioGroup ]),
      h('label.d-form-check', [ this._caseSensitivityCheckBox, i18n('casesensitivity.label') ]),
      h('h4', { id: combinationTypeLabelId }, i18n('combinationtype.label')),
      h('.form-group', [ this._combinationTypeRadioGroup ]));

    this.addEventListener('keydown', event => {
      if (event.keyCode === 13) {
        closePopup();
      }
    });
  }

}

customElements.define(COMPONENT_NAME, LikeConditionDropdown);
